import { useGameStore as e } from "../stores/game-store/useGameStore.js";
import { useCallback as t } from "react";
//#region src/lib/hooks/useExitCameraMode.ts
var n = () => {
	let n = e((e) => e.setActiveCinematicCamera);
	return t(() => {
		n(void 0);
	}, [n]);
};
//#endregion
export { n as useExitCameraMode };
